import Link from '@components/ui/link'
import Image from 'next/image'

interface PromotionProps {
  promotion_id: string
  title: string
  content?: string | null
  image: string
  author?: string | null
  card_title: string
  card_subtitle: string
  card_type: 'big_promotion' | string
  card_color?: string | null
  custom_card_color?: string
  button_text: string
  button_action: string
  image_url: string
  created_at: string
  published_at: string
}

const PromotionComponent: React.FC<{ promotion: PromotionProps }> = ({
  promotion,
}) => {
  const bgColor = promotion.custom_card_color
    ? `#${promotion.custom_card_color}`
    : '#21487D'
  const urlPath = new URL(promotion.button_action).pathname

  return (
    <div className="rounded-lg overflow-hidden shadow-none  sm:shadow-md flex flex-col lg:flex-row h-auto lg:min-h-80">
      {/* Text Section */}
      <div
        className={`w-full lg:w-1/2 xl:w-1/3 p-6 flex flex-col justify-center text-white  text-center`}
        style={{ backgroundColor: bgColor }}
      >
        <h2 className="text-xl md:text-2xl lg:text-3xl font-bold mb-2 md:mb-4 leading-snug">
          {promotion.card_title}
        </h2>
        <p className="text-sm md:text-base mb-2 md:mb-4">
          {promotion.card_subtitle}
        </p>
        {promotion.button_text && (
          <Link href={promotion.button_action} target="_blank">
            <button className="px-3 py-1.5 md:px-4 md:py-2 bg-white text-black rounded-md font-semibold hover:bg-gray-100 text-sm md:text-base">
              {promotion.button_text}
            </button>
          </Link>
        )}
      </div>

      {/* Image Section */}

      <div
        className={` w-full xl:w-2/3  lg:h-auto min-h-48  bg-[length:100%_100%]  bg-center  bg-no-repeat`}
        style={{
          backgroundImage: `url(${promotion.image_url})`,

          width: '100%',
        }}
      >
        <div className="w-full h-full aspect-[2.5/1] md:aspect-auto" />
      </div>
    </div>
  )
}

export default PromotionComponent
